import { ArrowLeft, ChevronLeft } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function BackBtn({ href = '/', btnText }) {
  return (
    <div className="docpro_back_btn">
      <div className='docpro_large_back'>
        <Link to={href} className="docpro_back_btn docpro_fw_500">
          <span>
            <ArrowLeft width={20} height={20} />
          </span>
          {btnText}
        </Link>
      </div>
      <div className='docpro_small_back'>
        <Link to={href} className="docpro_back_btn docpro_fw_500">
          <ChevronLeft width={27} height={27} />
          Back
        </Link>
      </div>
    </div>
  );
}
